import { Box, Card, CardContent, Container, Divider, Stack, styled } from '@ethings/ui-toolkit';
import { FC, type JSX } from 'react';
import { FlexBox } from '../../components';
import { useMaxScreen, useSidebarPinContext } from '../../hooks';

interface Props {
  avatarComponent: JSX.Element;
  content: JSX.Element;
  pageActions: JSX.Element;
  pageTitle: JSX.Element;
}

const StyledContainer = styled(Container)(({ theme }) => ({ marginTop: theme.spacing(3), marginBottom: theme.spacing(3) }));

export const ProfilePageDesktopLayout: FC<Props> = ({ avatarComponent, content, pageActions, pageTitle }) => {
  const { isPinned } = useSidebarPinContext();
  const mediumScreen = useMaxScreen('md');
  const largeScreen = useMaxScreen('lg');
  const breakpoint = isPinned ? largeScreen : mediumScreen;
  return (
    <FlexBox flexDirection="column" overflow="auto">
      <StyledContainer id="detail-page">
        <Stack id="page-header" className="detail-header" direction="column">
          {pageTitle}
        </Stack>

        <Box my={2} mx={0}>
          <Divider />
        </Box>
        <Stack id="content" className="detail-content" display="flex" direction={breakpoint ? 'column' : 'row'} spacing={4}>
          <Stack
            direction="column"
            flex={[2, 2]}
            spacing={2}
            minWidth={0}
          >
            <Card>
              <CardContent>
                {avatarComponent}
                <Box my={1} mx={0}>
                  <Divider />
                </Box>
                {pageActions}
              </CardContent>
            </Card>
          </Stack>

          <Stack
            direction="column"
            flex={[3, 3]}
            spacing={2}
            minWidth={0}
          >
            {content}
          </Stack>
        </Stack>
      </StyledContainer>
    </FlexBox>
  );
};
